export default function DeleteCampaignModal({
  setShowConfirmDelete,
  removeMarketingCampaign,
  campaign,
}) {
  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        backgroundColor: "rgba(0, 0, 0, 0.5)", // Fondo oscuro semitransparente
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999, // Aseguramos que esté por encima de todo el CRM
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          padding: "30px",
          borderRadius: "8px",
          textAlign: "center",
          maxWidth: "400px",
          boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
        }}
      >
        <h3 style={{ marginBottom: "15px", color: "#2B363D" }}>
          ¿Estás seguro de eliminar esta campaña?
        </h3>
        <p style={{ marginBottom: "25px", color: "#666" }}>
          Esta acción es irreversible. Perderás la plantilla y ya no podrás
          enviarla.
        </p>
        <div style={{ display: "flex", justifyContent: "center", gap: "15px" }}>
          <button
            className="buttonFormCancel"
            onClick={() => setShowConfirmDelete(false)} // Cierra el modal sin hacer nada
          >
            Cancelar
          </button>
          <button
            className="subHeader__btn"
            style={{
              backgroundColor: "#d9534f",
              borderColor: "#d9534f",
              color: "white",
            }} // Un rojo de advertencia
            onClick={() =>
              removeMarketingCampaign(campaign._id, campaign.image)
            } // Ejecuta el borrado real
          >
            Sí, eliminar
          </button>
        </div>
      </div>
    </div>
  );
}
